import type { ReactNode } from "react";

import {
  IconButton,
  SideNavigation,
  SideNavigationContent,
  SideNavigationFooter,
  SideNavigationHeader,
} from "@partners/ui";

import { LanguageSwitcher } from "@/components/Header/Authenticated/LanguageSwitcher";

type SideNavBarProps = {
  navLinksNodes: ReactNode[];
  isOpen: boolean;
  onClose: () => void;
};

export const SideNavBar = ({
  navLinksNodes,
  isOpen,
  onClose,
}: SideNavBarProps) => {
  return (
    <SideNavigation isOpen={isOpen}>
      <SideNavigationHeader>
        <div className="justify-end">
          <IconButton
            icon="cross"
            color="white"
            aria-label="Close"
            onClick={onClose}
          />
        </div>
      </SideNavigationHeader>
      <SideNavigationContent>
        <ul className="flex flex-col gap-4">
          <ul className="flex flex-col gap-4">
            {navLinksNodes.map((navLinkNode, index) => (
              <li key={`side-navigation-${index}`}>{navLinkNode}</li>
            ))}
          </ul>
        </ul>
      </SideNavigationContent>
      <SideNavigationFooter>
        <LanguageSwitcher isMobileVersion={true} />
      </SideNavigationFooter>
    </SideNavigation>
  );
};
